import React from 'react';
import SmartDialog from "../SmartDialog";
import {Button, ButtonGroup, Col, Row} from "reactstrap";
import DatePicker from 'react-datepicker';
import {MapView} from "./MapView";
import {EdgeDetection, Method, SelectMode} from './Constants';
import MDProgress from 'react-md-progress-bar';
import * as Geolib from 'geolib';
import _ from 'lodash';
import moment from 'moment';
import convert from 'convert-units';

import TTLAsyncProxy from "../../common/TTLAsyncProxy";
import {TrackerEndpoints} from "../../common/ProxyEndpoints";
import {Async as AsyncSelect, components} from "react-select";
import TwoLineItemRender from "../Elements/TwoLineItemRender";
import PropTypes from 'prop-types';
import HTML from '../../common/HtmlHelpers';
import Utils from "../../common/Utils";

/**
 *
 * @param center
 * @param size
 * @returns {google.maps.LatLngBounds}
 */
function calcBounds(center, size) {

    const google = window.google;
    var n = google.maps.geometry.spherical.computeOffset(center, size.height/2, 0).lat(),
        s = google.maps.geometry.spherical.computeOffset(center, size.height/2, 180).lat(),
        e = google.maps.geometry.spherical.computeOffset(center, size.width/2, 90).lng(),
        w = google.maps.geometry.spherical.computeOffset(center, size.width/2, 270).lng();

    return new google.maps.LatLngBounds(new google.maps.LatLng(s,w),
        new google.maps.LatLng(n,e))
}

/*
calcBounds(new google.maps.LatLng(40.626805,
                                -89.539396),
         new google.maps.Size(75,75)
*/

class AreaCalculator extends React.Component {

    static propTypes = {
        getTractorsUrl: PropTypes.func
    };

    constructor(props){
        super(props);
        this.proxy = TTLAsyncProxy.getInstance();
        this.state = {
            method: Method.Manual,
            selectMode: SelectMode.Rectangle,
            isLoading: false,
            selectedTractor: null,
            edgeDetection: EdgeDetection.None,
            tractors: null,
            rectangleOptions: {
                width: 10,   //  km
                height: 10,   //  km
                bounds: null
            },
            circleOptions: {
                radius: 10 // km
            },
            iterations: "10",
            steps: "30",
            circleScale: "1",
            historyData: null,
            startTime: null,
            endTime: null,
            enablePathDefinition: true,
            path: [], // custom path
            boundingBox: [], // bounding box for path
            areaEstimation: {
                acres: 0,
                hectares: 0,
                distance: 0,
                shapes: null
            }
        };

        //  compute area
        this.computeArea = this.computeArea.bind(this);
    }



    show({ historyData , tractor , start, end }){

        this.setState({
            startTime: start,
            endTime: end,
            historyData,
            method: historyData ? Method.Auto : Method.Manual,
            selectedTractor: tractor ?  { label: `${tractor.name} (${tractor.registration_number})` , value: tractor.id  , instance: tractor } : null
        },  () => {

            this._dlg.show(() => {

                window.setTimeout(async () => {

                    if(this.state.method === Method.Manual)
                        await this.updateSelectMode(this.state.selectMode);

                    if(_.isNil(historyData) && this._canLoadHistory()){
                        await this.loadHistoryData();
                    }

                    if(this.state.historyData){
                        this._map.fitView(this.state.historyData);
                    }

                }, 200);


            });



        });

    }



    handleCenterChanged(center){

        const { method , selectMode } = this.state;

        return new Promise((resolve => {

            if(method === Method.Manual && selectMode === SelectMode.Rectangle){

                return this.setState(state => ({
                    rectangleOptions: {
                        ...state.rectangleOptions,
                        bounds: this._computeRectangleBounds(center,state.rectangleOptions)
                    }
                }), resolve);

            }


            //  complete
            resolve();
        }));

    }

    async computeArea(){

        const google = window.google;

        const {
            method ,
            selectMode ,
            historyData ,
            edgeDetection ,
            path ,
            iterations,
            steps,
            circleScale,
            rectangleOptions,
            circleOptions
        } = this.state;

        let area = {
            acres: 0,
            hectares: 0,
            distance: 0,
            shapes: null // computation shapes
        };

        const computeTotalDistance = points => {

            return new Promise(((resolve) => {

                if(points.length <= 0)
                    return 0;

                let distance = 0;
                let pt1 = points[0];
                for(let i = 1; i < points.length; i++){
                    let pt2 = points[i];
                    distance += Geolib.getPreciseDistance(pt1,pt2);
                    pt1 = pt2;
                }

                resolve(Geolib.convertDistance(distance,'km'));
            }));

        };

        switch (method) {

            case Method.Auto:{

                if(edgeDetection === EdgeDetection.None){

                    const bounds = await new Promise((resolve => resolve(Geolib.getBounds(historyData))));
                    const _area = await new Promise((resolve) => resolve(Geolib.getAreaOfPolygon(historyData))) ;
                    area.hectares = Geolib.convertArea(_area,'ha');
                    area.acres = convert(area.hectares).from('ha').to('ac');
                    area.distance = await computeTotalDistance(historyData);
                    area.shapes = [
                        {
                            name: "Bounding Box",
                            type: "rectangle",
                            bounds: new google.maps.LatLngBounds(
                                new google.maps.LatLng(bounds.minLat, bounds.minLng),
                                new google.maps.LatLng(bounds.maxLat,bounds.maxLng)
                            ),
                            options: {
                                strokeColor: 'rgba(0,216,97,0.44)',
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                fillColor: 'rgba(59,255,44,0.22)',
                                fillOpacity: 0.35
                            }
                        }
                    ];

                }
                else if(edgeDetection === EdgeDetection.BoxSelection){

                    const totalIterations = Number(iterations);
                    const bounds = await new Promise((resolve => resolve(Geolib.getBounds(historyData))));
                    const bottomLeft = { lat: bounds.minLat, lng: bounds.minLng };
                    const bottomRight = { lat: bounds.maxLat, lng: bounds.minLng };
                    const topLeft = { lat: bounds.minLat, lng: bounds.maxLng };
                    const topRight = { lat: bounds.maxLat, lng: bounds.maxLng };
                    const center = Geolib.getCenter(historyData);

                    //  Moving anti clockwise
                    let outerPts = [];

                    const extractSegments = (from,to,angle , relativeDistance) => {

                        let increment  = relativeDistance / totalIterations;

                        let coveredDistance = 0;

                        while (coveredDistance < relativeDistance) {

                            let _v = Geolib.computeDestinationPoint(from,coveredDistance,angle);
                            outerPts.push(Geolib.findNearest(_v,historyData));
                            coveredDistance += increment;
                        }


                    };

                    const width = Geolib.getPreciseDistance(center,bottomLeft) * 2;
                    const height=  Geolib.getPreciseDistance(bottomRight,bottomLeft);

                    //  Top Right
                    extractSegments(topRight,topLeft,270 , width);

                    //  Top Left
                    extractSegments(bottomRight,bottomLeft,180,height);

                    //  Bottom Left
                    extractSegments(bottomLeft,bottomRight,90,width);

                    //  Bottom Right
                    extractSegments(topLeft,bottomLeft,0,height);

                    //  filter for unique points
                    let uniquePoints = _.uniq(outerPts);

                    // close poly
                    uniquePoints.push(uniquePoints[0]);

                    //  compute area
                    const _area = await new Promise((resolve) => resolve(Geolib.getAreaOfPolygon(uniquePoints))) ;
                    area.hectares = Geolib.convertArea(_area,'ha');
                    area.acres = convert(area.hectares).from('ha').to('ac');
                    area.distance = await computeTotalDistance(uniquePoints);
                    area.shapes = [
                        {
                            name: "Outer Points",
                            type: "line",
                            points: uniquePoints,
                            options: {
                                strokeOpacity: 0.8,
                                strokeColor: '#ffe438',
                            }
                        },
                        {
                            name: "Bounding Box",
                            type: "rectangle",
                            bounds: new google.maps.LatLngBounds(
                                new google.maps.LatLng(bottomRight.lat,bottomRight.lng),
                                new google.maps.LatLng(topLeft.lat,topLeft.lng),
                            ),
                            options: {
                                strokeColor: 'rgba(0,216,97,0.44)',
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                fillColor: 'rgba(59,255,44,0.22)',
                                fillOpacity: 0.35
                            }
                        }
                    ];
                }
                else if(edgeDetection === EdgeDetection.CircleSelection){

                    const increment = Number(steps);
                    const shapeScale = Number(circleScale);
                    const bounds = await new Promise((resolve => resolve(Geolib.getBounds(historyData))));
                    const center = Geolib.getCenter(historyData);
                    const radius = Geolib.getDistance(center,{ lat: bounds.maxLat , lng: bounds.maxLng }) * 1.015 * shapeScale;

                    let outerPts = [];
                    let angle = 0;
                    do {

                        let dest = Geolib.computeDestinationPoint(center,radius,angle);
                        outerPts.push(Geolib.findNearest(dest,historyData));
                        angle += increment;

                    }while (angle <= 360);

                    //  filter for unique points
                    let uniquePoints = _.uniq(outerPts);

                    // close poly
                    uniquePoints.push(uniquePoints[0]);

                    //  compute area
                    const _area = await new Promise((resolve) => resolve(Geolib.getAreaOfPolygon(uniquePoints))) ;
                    area.hectares = Geolib.convertArea(_area,'ha');
                    area.acres = Geolib.convertArea(_area,'a');
                    area.distance = await computeTotalDistance(uniquePoints);
                    area.shapes = [
                        {
                            name: "Outer Points",
                            type: "line",
                            points: uniquePoints,
                            options: {
                                strokeOpacity: 0.8,
                                strokeColor: '#ffe438',
                            }
                        },
                        {
                            name: "Bounding Box",
                            type: "rectangle",
                            bounds: new google.maps.LatLngBounds(
                                new google.maps.LatLng(bounds.minLat, bounds.minLng),
                                new google.maps.LatLng(bounds.maxLat,bounds.maxLng)
                            ),
                            options: {
                                strokeColor: 'rgba(0,216,97,0.44)',
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                fillColor: 'rgba(59,255,44,0.22)',
                                fillOpacity: 0.35
                            }
                        }
                    ];
                }

            }break;

            case Method.Manual: {

                if(selectMode === SelectMode.Rectangle){

                    const bounds = rectangleOptions.bounds;
                    if(bounds){
                        const ne = bounds.getNorthEast();
                        const sw = bounds.getSouthWest();

                        const topLeft = { lat: ne.lat() , lng: ne.lng() };
                        const topRight = { lat: sw.lat() , lng: ne.lng() };
                        const bottomLeft = { lat: ne.lat() , lng: sw.lng() };
                        const bottomRight = { lat: sw.lat() , lng: sw.lng() };

                        //  clockwise
                        const polygon = [
                            topRight,
                            bottomRight,
                            bottomLeft,
                            topLeft,

                            //  closed poly
                            topRight
                        ];

                        const _area = await new Promise((resolve) => resolve(Geolib.getAreaOfPolygon(polygon))) ;
                        area.hectares = Geolib.convertArea(_area,'ha');
                        area.acres = convert(area.hectares).from('ha').to('ac');
                        area.distance = 2 * rectangleOptions.width  + 2 * rectangleOptions.height // km;

                    }

                }
                else if(selectMode === SelectMode.Circle){

                    const radius = convert(circleOptions.radius).from('km').to('m'); // m
                    const _area = Math.PI * radius * radius;

                    area.hectares = Geolib.convertArea(_area,'ha');
                    area.acres = convert(area.hectares).from('ha').to('ac');
                    area.distance = 2 * Math.PI * radius;

                }
                else if(selectMode === SelectMode.UserDefined){

                    if(Array.isArray(path) && path.length >= 3){

                        const bounds = await new Promise((resolve => resolve(Geolib.getBounds(path))));
                        const _area = await new Promise((resolve) => resolve(Geolib.getAreaOfPolygon(path))) ;
                        area.hectares = Geolib.convertArea(_area,'ha');
                        area.acres = convert(area.hectares).from('ha').to('ac');
                        area.distance = await computeTotalDistance(path);
                        area.shapes = [
                            {
                                name: "Bounding Box",
                                condition: (ref) => ref.props.completePathDefinition === true,
                                type: "rectangle",
                                bounds: new google.maps.LatLngBounds(
                                    new google.maps.LatLng(bounds.minLat, bounds.minLng),
                                    new google.maps.LatLng(bounds.maxLat,bounds.maxLng)
                                ),
                                options: {
                                    strokeColor: 'rgba(0,216,97,0.44)',
                                    strokeOpacity: 0.8,
                                    strokeWeight: 2,
                                    fillColor: 'rgba(59,255,44,0.22)',
                                    fillOpacity: 0.35
                                }
                            }
                        ];
                    }


                }

            }break;

        }

        return area;
    }

    _canLoadHistory(){
        return this.state.selectedTractor && this.state.startTime && this.state.endTime;
    }

    /**
     * Loads history data
     */
    async loadHistoryData(){

        const { selectedTractor , startTime , endTime }  = this.state;

        this.setState({ isLoading: true });

        try{

            //  Replace with your logic
            const res = await this.proxy.processRequest( TrackerEndpoints.getTrackerLocationHistory(selectedTractor.instance.tracker.id, {
                start: moment(startTime).toDate().toJSON(),
                end: moment(endTime).toDate().toJSON()
            }));

            if(res.ok){

                const historyData = res.getPayload().filter(x => x.data_type == 1);
                this.setState({
                    historyData
                }, () => {
                    this._map.fitView(historyData);
                });

            }


        }
        catch (e) {

            //  Trace exception
            HTML.toastError(Utils.getResponseError(e));

        }
        finally {

            this.setState({
                isLoading: false
            });

        }

    }

    updateMethod(method){

        this.setState({
            method
        }, async () => {

            let args;
            switch (method) {

                case Method.Manual:

                    args = {
                        type: this.state.selectMode,
                        bounds: this.state.rectangleOptions.bounds,
                        radius: convert(Number(this.state.circleOptions.radius)).from('km').to('m')
                    };

                    break;
                default:
                    args = {};
            }

            //  run actions here...
            this._map.toggleMode(method,args);

            //  recompute area
            await this.refreshAreaCalculation();
        })
    }

    updateSelectMode(mode){

        this.setState({
            selectMode: mode
        }, async () => {

            await this.handleCenterChanged(this._map.getCenter());

            //  run actions here...
            return this.updateMethod(Method.Manual);

        });

    }

    /**
     * Refresh area calculation displayed
     */
    async refreshAreaCalculation(){

        //  ensure calculation is possible

        try{

            const area = await this.computeArea();

            this.setState({
                areaEstimation: area
            });

        }
        catch (e) {

            //  Failed calculating area
        }


    }

    _computeRectangleBounds(center,rectOptions){
        return calcBounds(center,new window.google.maps.Size(
            convert(Number(rectOptions.width)).from('km').to('m'),
            convert(Number(rectOptions.height)).from('km').to('m')));
    }

    render() {

        const { method , selectMode , areaEstimation , isLoading } = this.state;

        const renderSelectModeOptions = () => {

            switch (selectMode) {
                case SelectMode.Rectangle:

                    const rectangleOptions = this.state.rectangleOptions;
                    return <React.Fragment>
                            <span>Width (km): <input type="number"
                                                     value={rectangleOptions.width}
                                                     onChange={evt => {

                                                         let _opts = {
                                                             ...rectangleOptions,
                                                             width: evt.target.value || 1
                                                         };

                                                         _opts.bounds = this._computeRectangleBounds(this._map.getCenter(), _opts );

                                                         this.setState({
                                                             rectangleOptions: _opts
                                                         }, () => this.updateMethod(method));

                                                     }}
                                                     min={1}
                                                     max={999999}
                                                     placeholder="Width"/></span>


                        <span className="ml-4">Height (km): <input type="number"
                                                                   value={rectangleOptions.height}
                                                                   onChange={evt => {

                                                                       let _opts = {
                                                                           ...rectangleOptions,
                                                                           height: evt.target.value || 1
                                                                       };

                                                                       _opts.bounds = this._computeRectangleBounds(this._map.getCenter(), _opts );

                                                                       this.setState({
                                                                           rectangleOptions: _opts
                                                                       }, () => this.updateMethod(method));

                                                                   }}
                                                                   min={1}
                                                                   max={999999}
                                                                   placeholder="Height"/></span>
                    </React.Fragment>;

                case SelectMode.Circle:

                    const circleOptions = this.state.circleOptions;
                    return <React.Fragment>
                        <span>Radius (km): <input type="number"
                                                  value={circleOptions.radius}
                                                  onChange={evt => {

                                                      this.setState({

                                                          circleOptions: {
                                                              ...circleOptions,
                                                              radius: evt.target.value || 1
                                                          }

                                                      }, () => this.updateMethod(method));

                                                  }}
                                                  min={1}
                                                  max={999999}
                                                  placeholder="Radius"/></span>
                    </React.Fragment>;

                case SelectMode.UserDefined:

                    return  <React.Fragment>
                        <ButtonGroup>
                            <Button color="danger" size="sm" disabled={this.state.path.length === 0} onClick={() => {

                                this.setState({
                                    path: [],
                                    enablePathDefinition: true
                                });

                            }}><i className="fa fa-remove"/> Clear/Restart</Button>
                            <Button size="sm" disabled={!this.state.enablePathDefinition} onClick={() => {

                                this.setState(state => ({
                                    path: state.path.concat([ state.path[state.path.length - 1] ]),
                                    enablePathDefinition: false
                                }), () => this.refreshAreaCalculation());


                            }}><i className="fa fa-circle"/> Close Path</Button>
                        </ButtonGroup>
                    </React.Fragment>

            }

            return  null;
        };

        return (<SmartDialog title="Area Calculator" large ref={r => this._dlg = r}>
            <div>

                <div className="clearfix text-right">

                    <div className="pull-left">
                        {method === Method.Auto && <h5><i className="fa fa-magic"/> Automatic Calculation</h5>}
                        {method === Method.Manual && <h5><i className="fa fa-hand-pointer-o"/> Manual Estimation</h5>}
                    </div>

                    <div className="pull-right" />
                    <ButtonGroup>
                        <Button active={method === Method.Auto} onClick={() => this.updateMethod(Method.Auto)}><i className="fa fa-magic"/> Automatic</Button>
                        <Button active={method === Method.Manual} onClick={() => this.updateMethod(Method.Manual)}><i className="fa fa-hand-pointer-o"/> Manual</Button>
                    </ButtonGroup>
                </div>

                <hr/>


                <Row>
                    <Col md={6}>

                        <AsyncSelect  name="tractor"
                                      defaultOptions
                                      cacheOptions
                                      placeholder="Search tractor..."
                                      value={this.state.selectedTractor}
                                      onChange={value => {

                                          if(value && this.state.selectedTractor === value)
                                              return;

                                          let _payload = {
                                              selectedTractor: value
                                          };


                                          if(value){
                                              _payload.startTime = null;
                                              _payload.endTime = null;
                                          }

                                          this.setState(_payload, async () => {

                                              if(this._canLoadHistory()){
                                                  await this.loadHistoryData();
                                              }

                                          });

                                      }}
                                      components={{
                                          Option: ({ children , ...props }) => {

                                              const tractor = props.data.instance;
                                              return <components.Option {...props}>

                                                  <TwoLineItemRender media={tractor.media}
                                                                     line1Value={`${tractor.name} (${tractor.registration_number})`}
                                                                     line2Prefix="Chassis"
                                                                     line2Value={tractor.chassis}/>

                                              </components.Option>

                                          }
                                      }}
                                      loadOptions={async (value) => {

                                          try {

                                              const res = await this.proxy.processRequest(this.props.getTractorsUrl(), {
                                                  search: { keyword: value , method: 'inside', fields: ['name','chassis', 'registration_number' ] },
                                                  pagination: { page: 1 , perPage : 5 },
                                                  include: [ 'media' , 'tracker' ],
                                                  query:{
                                                      tracked: true
                                                  }
                                              });

                                              return res.getPayload().map(t => ({ label: `${t.name} (${t.registration_number})` , value: t.id  , instance: t }));
                                          }
                                          catch (e) {

                                              // failed to load query

                                          }

                                      }}/>

                    </Col>

                    <Col md={3}>

                        <DatePicker placeholderText="Select start date"
                                    selected={this.state.startTime}
                                    showTimeInput
                                    isClearable
                                    className="form-control"
                                    onChange={value => {

                                        if(!_.isNil(value) && this.state.endTime && moment(value).isAfter(moment(this.state.endTime))){
                                            return window.alert('Start date cannot be greater than end date');
                                        }

                                        this.setState({
                                            startTime: value
                                        }, async () => {

                                            if(this._canLoadHistory()){
                                                await this.loadHistoryData();
                                            }
                                        });

                                    }}/>
                    </Col>

                    <Col md={3}>

                        <DatePicker placeholderText="Select end date"
                                    selected={this.state.endTime}
                                    showTimeInput
                                    isClearable
                                    className="form-control ml-2"
                                    onChange={value => {

                                        if(!_.isNil(value) && this.state.startTime && moment(value).isBefore(moment(this.state.startTime))){
                                            return window.alert('End date should be greater than start date')
                                        }

                                        this.setState({
                                            endTime: value
                                        }, async () => {

                                            if(this._canLoadHistory()){
                                                await this.loadHistoryData();
                                            }

                                        });

                                    }}/>
                    </Col>

                </Row>

                {method === Method.Manual &&<div className="clearfix p-3 mt-2" style={{ backgroundColor: 'rgba(226,226,226,0.31)' }}>

                    <div className="fa-pull-left">
                        {renderSelectModeOptions()}
                    </div>

                    <ButtonGroup className="pull-right">
                        <Button size="sm" style={{ zIndex: "inherit" }} active={selectMode === SelectMode.Rectangle} onClick={() => this.updateSelectMode(SelectMode.Rectangle)}><i className="fa fa-square"/> Rectangle</Button>
                        <Button size="sm" style={{ zIndex: "inherit" }} active={selectMode === SelectMode.Circle} onClick={() => this.updateSelectMode(SelectMode.Circle)}><i className="fa fa-circle"/> Circle</Button>
                        <Button size="sm" style={{ zIndex: "inherit" }} active={selectMode === SelectMode.UserDefined} onClick={() => this.updateSelectMode(SelectMode.UserDefined)}><i className="fa fa-plus-circle"/> Select Points</Button>
                    </ButtonGroup>

                </div>}

                {method === Method.Auto &&<div className="p-3 mt-2" style={{ backgroundColor: 'rgba(226,226,226,0.31)' }}>
                    <span>Edge Detection: <select value={this.state.edgeDetection} onChange={evt => {

                        this.setState({
                            edgeDetection: evt.target.value
                        }, () => this.updateMethod(method));

                    }}>
                        <option value={EdgeDetection.None}>None</option>
                        <option value={EdgeDetection.BoxSelection}>Box Selection (Accurate)</option>
                        <option value={EdgeDetection.CircleSelection}>Circle Selection (Efficient)</option>
                    </select></span>

                    {this.state.edgeDetection === EdgeDetection.BoxSelection && <span className="ml-4">Max Iterations: <select value={this.state.iterations} onChange={evt => {

                        this.setState({
                            iterations: evt.target.value
                        }, () => this.updateMethod(method));

                    }}>
                        <option value={"10"}>Regular (10 pts)</option>
                        <option value={"50"}>Medium (50 pts)</option>
                        <option value={"200"}>Very High (200 pts)</option>
                    </select></span>}

                    {this.state.edgeDetection === EdgeDetection.CircleSelection && <React.Fragment>
                        <span className="ml-4">Total Steps: <select value={this.state.steps} onChange={evt => {

                            this.setState({
                                steps: evt.target.value
                            }, () => this.updateMethod(method));

                        }}>
                        <option value={"60"}>Standard</option>
                        <option value={"30"}>Medium</option>
                        <option value={"5"}>Detailed</option>
                    </select>
                        </span>

                        <span className="ml-4">Scale: <input type={"number"} min={0.001} step="0.001" max={999} value={this.state.circleScale} onChange={evt => {

                            this.setState({
                                circleScale: evt.target.value || 1
                            }, () => this.updateMethod(method));

                        }}/>
                        </span>

                    </React.Fragment>}

                </div>}

                {isLoading && <MDProgress show/>}

                <div style={{ backgroundColor: "#FFF" , marginTop: 12 }}>

                    <MapView ref={r => this._map = r}
                             historyPath={this.state.historyData}
                             computationShapes={areaEstimation.shapes}
                             userPath={this.state.path}
                             completePathDefinition={!this.state.enablePathDefinition}
                             onPathUpdated={path => {

                                 this.setState({
                                     path
                                 }, () => this.refreshAreaCalculation());

                             }}
                             onCircleRadiusChanged={radius => {

                                 this.setState(state => ({
                                     circleOptions: {
                                         ...state.circleOptions,
                                         radius: convert(radius).from('m').to('km')
                                     }
                                 }), () => this.refreshAreaCalculation());

                             }}
                             onRectBoundsChanged={bounds => {

                                 const ne = bounds.getNorthEast();
                                 const sw = bounds.getSouthWest();

                                 const topLeft = { lat: ne.lat() , lng: ne.lng() };
                                 const topRight = { lat: sw.lat() , lng: ne.lng() };
                                 const bottomLeft = { lat: ne.lat() , lng: sw.lng() };

                                 this.setState(state => ({
                                     rectangleOptions: {
                                         ...state.rectangleOptions,
                                         bounds: bounds,
                                         height: Geolib.convertDistance( Geolib.getPreciseDistance(topLeft,topRight) , 'km'),
                                         width: Geolib.convertDistance(  Geolib.getPreciseDistance(bottomLeft,topLeft) , 'km' )
                                     }
                                 }), () => this.refreshAreaCalculation())

                             }}
                             onPathDefinitionComplete={path => {

                                 this.setState({
                                     path,
                                     enablePathDefinition: false
                                 }, () => this.refreshAreaCalculation());

                             }}
                             onCenterChanged={async center => {

                                 // center changed
                                 await this.handleCenterChanged(center);

                                 // update map view
                                 this.updateMethod(method);

                             }}/>

                </div>

                <hr/>

                <div className="p-3" style={{ backgroundColor: "#f6f6f6"}}>
                    <h5><i className="fa fa-area-chart"/> Estimated Area</h5>
                    <div><span>{areaEstimation.hectares.toLocaleString('en-us',{ maximumFractionDigits: 2 })} <b>hectares</b></span></div>
                    <div><span>{areaEstimation.acres.toLocaleString('en-us',{ maximumFractionDigits : 2})} <b>acres</b></span></div>
                    <hr/>
                    <div><span><b>Total Distance:</b> {areaEstimation.distance.toLocaleString('en-us',{ maximumFractionDigits : 2})} km</span></div>
                </div>

            </div>
        </SmartDialog>);
    }


}

export default AreaCalculator;



// WEBPACK FOOTER //
// ./src/components/AreaCalculatorDialog/AreaCalculator.js